// Slot / time helpers mirrored from the backend config (5-min weekly grid).

export function slotToLabel(config, slot) {
  const min = config.day_start_min + slot * config.slot_min;
  const h = Math.floor(min / 60);
  const m = min % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

export function hhmmToSlot(config, hhmm) {
  const [h, m] = hhmm.split(":").map(Number);
  return Math.floor((h * 60 + m - config.day_start_min) / config.slot_min);
}

// Time <select> options for a single day, plus the closing boundary.
export function dayTimeOptions(config) {
  if (!config) return [];
  const opts = (config.slot_labels || []).map((l) => ({ value: l, label: l }));
  const end = `${String(Math.floor(config.day_end_min / 60)).padStart(2, "0")}:${String(config.day_end_min % 60).padStart(2, "0")}`;
  opts.push({ value: end, label: end });
  return opts;
}

// Absence slots for ONE calendar day: { agentId: Set(slot) }.
export function absenceCellsForDay(config, absences, dateStr) {
  const map = {};
  const parse = (iso) => {
    const [d, t] = iso.split("T");
    return { d, t: (t || "00:00").slice(0, 5) };
  };
  for (const ab of absences) {
    const s = parse(ab.start_datetime);
    const e = parse(ab.end_datetime);
    if (dateStr < s.d || dateStr > e.d) continue;
    const start = dateStr === s.d ? Math.max(0, hhmmToSlot(config, s.t)) : 0;
    const end = dateStr === e.d ? Math.min(config.slots_per_day, hhmmToSlot(config, e.t)) : config.slots_per_day;
    if (!map[ab.agent_id]) map[ab.agent_id] = new Set();
    for (let t = start; t < end; t++) map[ab.agent_id].add(t);
  }
  return map;
}

export const PRIORITY_LABEL = {
  1: "P1 · Critical", 2: "P2 · High", 3: "P3 · Standard", 4: "P4 · Low", 5: "P5 · Optional",
};

// Descriptive options for the P1–P5 priority dropdown.
export const PRIORITY_OPTIONS = [
  { value: "1", label: "P1 · Critical / Highest" },
  { value: "2", label: "P2 · High" },
  { value: "3", label: "P3 · Standard" },
  { value: "4", label: "P4 · Low" },
  { value: "5", label: "P5 · Optional / Lowest" },
];

// "2026-06-15" -> "Monday (June 15)"
export function formatDayLong(dateStr) {
  if (!dateStr) return "";
  const d = new Date(`${dateStr}T00:00:00`);
  if (isNaN(d)) return dateStr;
  const wd = d.toLocaleDateString("en-US", { weekday: "long" });
  const mo = d.toLocaleDateString("en-US", { month: "long" });
  return `${wd} (${mo} ${d.getDate()})`;
}

// Duration in hours between two "HH:MM" (crossing midnight when end <= start).
export function shiftHours(start, end) {
  const [sh, sm] = start.split(":").map(Number);
  const [eh, em] = end.split(":").map(Number);
  let a = sh * 60 + sm;
  let b = eh * 60 + em;
  if (b <= a) b += 1440;
  return (b - a) / 60;
}
